import { render, staticRenderFns } from "./LoadNewData.vue?vue&type=template&id=21b8ca11&"
import script from "./LoadNewData.vue?vue&type=script&lang=js&"
export * from "./LoadNewData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports